import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`;
